import React, { useMemo } from 'react';
import { useHtmlClassService } from '../../_core/MetronicLayout';
import { Topbar } from './Topbar';
import { AnimateLoading } from '../extras/controls';

export function Header({ hideSidebar = false }) {
	const uiService = useHtmlClassService();

	const layoutProps = useMemo(() => {
		return {
			headerClasses: uiService.getClasses('header', true),
			headerAttributes: uiService.getAttributes('header'),
			headerContainerClasses: uiService.getClasses('header_container', true),
		};
	}, [uiService]);

	return (
		<>
			{/*begin::Header*/}
			<div
				className={`header ${layoutProps.headerClasses} pl-0 ${
					hideSidebar ? 'hidden-sidebar' : ''
				}`}
				id="kt_header"
				{...layoutProps.headerAttributes}
			>
				{/*begin::Container*/}
				<div
					className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-end`}
				>
					<AnimateLoading />
					{/*begin::Topbar*/}
					<Topbar />
					{/*end::Topbar*/}
				</div>
				{/*end::Container*/}
			</div>
			{/*end::Header*/}
		</>
	);
}
